/* eslint-disable @typescript-eslint/explicit-function-return-type */
// We are using a custom loader function so we have to `use client` here as per Next's documentation: https://nextjs.org/docs/app/api-reference/components/image#loader

'use client'

import NextImage, {
} from 'next/image'
import { type ImageProps, srcIsStoryblokAsset, storyblokImageLoader } from './utils'

const Image = ({
  src,
  alt,
  width,
  height,
  fill,
  sizes,
  quality,
  loading,
  priority,
  blurDataURL,
  placeholder,
  className,
  style
}: ImageProps) => {
  const loader = srcIsStoryblokAsset(src) ? storyblokImageLoader : undefined

  return (
    <NextImage
      loader={loader}
      src={src}
      alt={alt}
      width={width}
      height={height}
      fill={fill}
      sizes={sizes}
      quality={quality}
      loading={loading}
      priority={priority}
      blurDataURL={blurDataURL}
      placeholder={placeholder}
      className={className}
      style={style}
    />
  )
}

export { Image, type ImageProps }
